import React, { useEffect } from "react";

import { ReactComponent as HeadsetSvg } from "../../assets/icons/headset-mobile.svg";
import { ReactComponent as FolderSwitchSvg } from "../../assets/icons/flip-camera.svg";
import { useAudioVideoContext } from "../../hooks/useContext";

const VideoAudioControls = (props) => {
  const { showAudioOptions, setShowAudioOptions } = props;

  const [showFlip, setShowFlip] = React.useState(false);

  const { cutSound, toggleCameraFacingMode, videoEnabled, setVideoEnabled } =
    useAudioVideoContext();

  const handleSwitchCamera = () => {
    const prev = videoEnabled;

    setVideoEnabled(false);
    toggleCameraFacingMode();

    if (prev) {
      setTimeout(() => {
        setVideoEnabled(true);
      }, 500);
    }
  };

  const handleSpeakerIconClick = () => {
    if (setShowAudioOptions) {
      setShowAudioOptions(!showAudioOptions);
    }
  };

  const getCameraDevices = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(
      (device) => device.kind === "videoinput"
    ).length;

    if (videoDevices > 1) {
      setShowFlip(true);
    }
  };

  getCameraDevices();

  return (
    <>
      <div className="navbar__options__controls">
        <button
          className={"control__audio"}
          onClick={handleSpeakerIconClick}
          data-size={"large"}
        >
          <HeadsetSvg />
        </button>
        <button
          className={"control__audio"}
          onClick={handleSwitchCamera}
          data-size={"large"}
        >
          {showFlip && <FolderSwitchSvg />}
        </button>
      </div>
    </>
  );
};

export default VideoAudioControls;
